// In the data/boat.js file

export const table = {
    "success": true,
    "message": "เรียกข้อมูลสำเร็จ",
    "result": [
        {
            "loginId": 46,
            "employeeId": "CE2408234",
            "email": "nirav@gmail.com",
            "name": "Nirav",
            "surname": "Joshi",
            "position": "Manager",
            "picture": "https://files.takeket.co/uploads/avatar.webp",
        },
        {
            "loginId": 140,
            "employeeId": "CE24101632",
            "email": "Kanyanat.ampare@gmail.com",
            "name": "มาดแมน",
            "surname": "แสนดี",
            "position": "IT",
            "picture": "https://files.takeket.co/uploads/avatar3.webp",
        }
    ]
}

export const tableBank = {
    "success": true,
    "message": "เรียกข้อมูลสำเร็จ",
    "result": [
        {
            "id": 1,
            "name": "Kbank",
            "balance": 100.00,
            "balanceTran": 1000,
            "password": 1234,
            "bankNo": "11000100"
        },
        {
            "id": 2,
            "name": "SCB",
            "balance": 200.00,
            "balanceTran": 3000,
            "password": 4321,
            "bankNo": "2222333333"
        },
    ]
}